import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import {
  radii,
  shadows,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";
import type { Space } from "./types";

export function Card({
  children,
  danger = false,
  accent = "none",
  compact = false,
  gap,
}: {
  children: ReactNode;
  danger?: boolean;
  /** Soft left accent for metrics / emphasis without double nesting. */
  accent?: "none" | "mint" | "danger";
  compact?: boolean;
  gap?: Space;
}) {
  const { stylesheet, gapStyles } = useThemedStyles(makeStyles);
  const resolvedAccent = danger ? "danger" : accent;

  return (
    <View
      style={[
        stylesheet.card,
        resolvedAccent === "mint" ? stylesheet.mint : null,
        resolvedAccent === "danger" ? stylesheet.danger : null,
        stylesheet.shadow,
        compact ? stylesheet.compact : null,
        gap ? gapStyles[gap] : null,
      ]}
    >
      {children}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    card: {
      padding: spacing.l,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: radii.card,
      backgroundColor: colors.elevated,
    },
    mint: {
      borderLeftWidth: 4,
      borderLeftColor: colors.primary,
    },
    danger: {
      borderColor: colors.danger,
      borderLeftWidth: 4,
      borderLeftColor: colors.danger,
      backgroundColor: colors.dangerSurface,
    },
    shadow: shadows.card,
    compact: { padding: spacing.m },
    gapXs: { gap: spacing.xs },
    gapSm: { gap: spacing.s },
    gapMd: { gap: spacing.m },
    gapLg: { gap: spacing.l },
  });
  return {
    stylesheet,
    gapStyles: {
      xs: stylesheet.gapXs,
      sm: stylesheet.gapSm,
      md: stylesheet.gapMd,
      lg: stylesheet.gapLg,
    },
  };
};
